// Observed Metadata.
import ObservedSVG from '../../../assets/images/Thoughts/DoYouCare.svg';

const DoYouCare = {
  id: 'DoYouCare',
  title: 'Computational Compassion',
  description: 'Is this functionally equivalent to caring?',
  thumbnail: ObservedSVG,
  featured: false,
};

export default DoYouCare;
